import React from 'react';
import { Plus, Eye, Lock, FileText } from 'lucide-react';

const fmt = (n) =>
  parseFloat(n || 0).toLocaleString('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ListadoIR13({ ir13List, onSelect, onCrear, loading }) {
  return (
    <div className="space-y-4">

      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-base font-bold text-gray-900">IR-13 — Retenciones Anuales ISR</h2>
          <p className="text-xs text-gray-400 mt-0.5">Declaración Jurada Anual · DGII República Dominicana</p>
        </div>
        <button
          onClick={onCrear}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Plus size={14} />
          Nuevo IR-13
        </button>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex items-center justify-center py-20">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
        </div>
      ) : ir13List.length === 0 ? (
        <div className="bg-white border border-gray-200 rounded-xl flex flex-col items-center justify-center py-20">
          <FileText size={40} className="text-gray-200 mb-3" />
          <p className="text-sm font-medium text-gray-500">No hay declaraciones IR-13</p>
          <p className="text-xs text-gray-400 mt-1">Genera tu primera declaración haciendo clic en "Nuevo IR-13".</p>
        </div>
      ) : (
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Año</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Empleados</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Pagado</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">ISR Retenido</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">ISR Liquidado</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Saldo Favor</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Por Pagar</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Estado</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {ir13List.map(ir13 => {
                const cerrado = ir13.estado === 'cerrado';
                return (
                  <tr key={ir13.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3">
                      <p className="font-bold text-gray-900 text-base">{ir13.anio}</p>
                    </td>
                    <td className="px-4 py-3 text-right text-gray-700 font-medium">
                      {ir13.total_empleados}
                    </td>
                    <td className="px-4 py-3 text-right text-gray-700">
                      RD$ {fmt(ir13.total_pagado)}
                    </td>
                    <td className="px-4 py-3 text-right text-gray-700">
                      RD$ {fmt(ir13.total_isr_retenido)}
                    </td>
                    <td className="px-4 py-3 text-right text-gray-700">
                      RD$ {fmt(ir13.total_isr_liquidado)}
                    </td>
                    <td className="px-4 py-3 text-right">
                      {parseFloat(ir13.total_saldo_favor) > 0
                        ? <span className="font-semibold text-green-700">RD$ {fmt(ir13.total_saldo_favor)}</span>
                        : <span className="text-gray-300">—</span>}
                    </td>
                    <td className="px-4 py-3 text-right">
                      {parseFloat(ir13.total_monto_pagar) > 0
                        ? <span className="font-semibold text-red-700">RD$ {fmt(ir13.total_monto_pagar)}</span>
                        : <span className="text-gray-300">—</span>}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {cerrado ? (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
                          <Lock size={10} /> Cerrado
                        </span>
                      ) : (
                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
                          Borrador
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-right">
                      <button
                        onClick={() => onSelect(ir13)}
                        className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs border border-gray-200 rounded-lg hover:bg-gray-50 text-gray-600 transition-colors"
                      >
                        <Eye size={12} />
                        Ver
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
